/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ServizioMensaReportType } from './servizio-mensa-report-type';


export interface ServizioMensaReportListFilter { 
    tipo?: ServizioMensaReportType;
    data_da?: string;
    data_a?: string;
}



